import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { UserSettings } from '../../models/user-settings.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService extends BaseService<UserSettings> {

  endpointUri = 'UserSettings';

  getAll(): Observable<any> {
    return this.getAllRequest();
  }

  get(id: string): Observable<any> {
    return this.getRequest(id);
  }

  getSettings(settingsKey: string): Observable<any> {
    return this.getRequest(settingsKey, this.endpointUri);
  }

  createSettings(settingsKey: string, settingsModel) {
    return this.patchRequest(settingsKey, this.endpointUri, settingsModel, null);
  }

  deleteSettings(settingsKey: string, settingsModel = undefined) {
    return this.updateRequest(settingsKey, this.endpointUri, settingsModel, null);
  }

  add(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  update(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  delete(): Observable<{}> {
    throw new Error('Method not implemented.');
  }

}
